import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IGameInfo } from "../interfaces/game-info";
import { IPublishedGamesState } from "../interfaces/slices";

const initialState: IPublishedGamesState = {
    info: {}
}

export const publishedGamesSlice = createSlice({
    name: 'publishedGames',
    initialState,
    reducers: {
        addPublishedGames: (state, action: PayloadAction<Array<IGameInfo>>) => {
            state.info = {};
            action.payload.forEach((info: IGameInfo) => {
                state.info[info.gameName] = info;
            })
        },
    },
})

export const { addPublishedGames } = publishedGamesSlice.actions
export default publishedGamesSlice.reducer;